import { axios } from '@/utils/request'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
// 热销商品
export function getHotProduct(params) {
  let url = '/distribution/basicProduct'
  if (!Vue.ls.get(ACCESS_TOKEN)) {
    url = '/frontend/basicProduct'
  }
  return axios({
    url: url,
    method: 'GET',
    params
  })
}
// 公告列表
export function getFrontendNoticeList(params) {
  return axios({
    url: '/frontend/systemNotice',
    method: 'GET',
    params
  })
}
// 查看公告
export function viewNotice(id) {
  return axios({
    url: '/frontend/systemNotice/' + id,
    method: 'GET'
  })
}

// gebox
export function viewImg3D() {
  return axios({
    url: '/frontend/systemConfig/getSpinImg',
    method: 'GET'
  })
}
// getVideo
export function getVideo() {
  return axios({
    url: '/frontend/systemConfig/getTvVideoUrl',
    method: 'GET'
  })
}

// get3Video
export function get3Video() {
  return axios({
    url: '/frontend/systemConfig/getBasicProductVideo',
    method: 'GET'
  })
}
// 获取产品定制鼠标结果列表
export function getHomeBasicProducts() {
  return axios({
    url: '/frontend/basicProduct/homeBasicProducts',
    method: 'GET'
  })
}

// 获取主题
export function getSpecial() {
  return axios({
    url: '/frontend/basicProduct/special',
    method: 'GET'
  })
}

// 提交邮箱
export function addPublicityRecord(data) {
  return axios({
    url: '/frontend/publicityRecord',
    method: 'POST',
    data
  })
}
